export default ({ request }) => ({
    opaEcomEvgExpenseApi(code) {
        return request({
            url: '/ecom/opa/evg/expense/getByCode',
            method: 'GET',
            params: { code },
        })
    },
})